<template>
    <div
        :id="`gc-section-wrapper-${sectionId}`"
        class="gc-section-action-wrapper v-card v-sheet theme--light v-card--flat pa-3 my-2 rounded-lg apply-border"
        @mouseenter="showToolbar = true"
        @mouseleave="showToolbar = false">

        <content-section-toolbar
            :sectionId="contentSection.sectionId"
            :visible="showToolbar"
            :contentRestrictions="contentSection.contentRestrictions"
            @copy="copyTextClicked"
            @bookmark="bookmarkClicked"
            @print="printClicked"
            @share="shareClicked"
            @fireMobileActions="mobileActionClicked"
        />

        <content-section-title
            :title="contentSection.title"
            :contentId="contentSection.sectionId"
            :documentId="contentSection.documentId"
            :isLink="isLink(contentSection)"/>

        <content-section-content
            :content="contentSection.content"
            :documentId="contentSection.documentId"
            @text-highlighted="textHighlighted"
            :sectionId="contentSection.sectionId"
            :contentModifiers="contentModifiers"/>

        <content-section-insights/>

        <content-section-user-bookmarks
            :bookmarks="contentSection.bookmarks"
            :tags="tags"
            :sectionId="contentSection.sectionId"
        />

        <content-section-breadcrumb
            v-if="contentSection?.breadcrumbs?.length !== 0"
            :breadcrumbs="contentSection?.breadcrumbs"
            @breadcrumb-clicked="handleBreadcrumbClick"
        />
    </div>
</template>

<script>
import ContentSectionToolbar from "./ContentSectionToolbar.vue";
import ContentSectionTitle from "./ContentSectionTitle.vue";
import ContentSectionContent from "./ContentSectionContent.vue";
import ContentSectionInsights from "./ContentSectionInsights.vue";
import ContentSectionUserBookmarks from "./ContentSectionUserBookmarks.vue";
import ContentSectionBreadcrumb from "./ContentSectionBreadcrumb.vue";
import ItemBreadcrumb from "../search/content/result/item_breadcrumb.vue";
import ContentSectionType from "./types/contentSectionType";
import NewToolBarActions from "./mixins/NewToolBarActions";
import { AnnotationSelectionHandler } from "./utils/AnnotationSelectionHandler";

export default {
    components: {
        ItemBreadcrumb,
        ContentSectionBreadcrumb,
        ContentSectionUserBookmarks,
        ContentSectionInsights,
        ContentSectionContent,
        ContentSectionTitle,
        ContentSectionToolbar
    },
    props: {
        /**
         * @type {ContentSectionType}
         */
        contentSection: {
            type: Object,
            required: true
        },
        /**
         * @type {Array<ContentModifier>}
         */
        contentModifiers: {
          type: Array,
          required: true
        }
    },
    mixins: [NewToolBarActions],
    data() {
        return {
            showToolbar: false,
            highlightedText: null,
            tags: ["Important", "Review", "Highlight"],
        }
    },
    computed: {
        contentId() {
            return this.contentSection.contentId;
        },
        sectionId() {
            return this.contentSection.sectionId;
        },
        sectionTitle() {
            return this.contentSection.title;
        },
        documentId() {
            return this.contentSection.documentId;
        },
        sectionContent(){
            return this.contentSection.content;
        }
    },
    methods: {
        textHighlighted(selectionObject) {
            // TODO
        },

        handleBreadcrumbClick(breadcrumbItem) {
            this.$emit('breadcrumb-clicked', breadcrumbItem);
        },

        isLink(section){
            return !section.isChapter;
        },

        copyTextClicked() {
            this.copyTextAction(this.sectionId);
        },

        bookmarkClicked() {
            const highlightedText = AnnotationSelectionHandler.highLightedSectionContent(this.sectionId);
            //if selected any text then apply note/annotation
            if (highlightedText) {
                this.toggleNoteActionNew(null, {
                    sectionId: this.sectionId,
                    documentId: this.documentId,
                    highlightedText: highlightedText,
                });
            } else {
                this.toggleBookmarkActionNew(null, {
                    sectionTitle: this.sectionTitle,
                    sectionId: this.sectionId,
                    documentId: this.documentId
                });
            }
        },

        printClicked() {
            this.printAction(this.documentId, this.sectionId);
        },

        shareClicked() {
            this.shareLinkAction(this.sectionId);
        },

        mobileActionClicked(){
            const sectionDetails = {
                sectionId: this.sectionId,
                documentId: this.documentId,
                sectionTitle: this.sectionTitle,
                sectionContent: this.sectionContent,
                hasContentPremium: true,
            }
            this.mobileActionFired(sectionDetails);
        },
    }
}
</script>

<style scoped lang="scss">
    .gc-section-action-wrapper {
        ::selection {
            background: #FFFF00;
        }
        ::-moz-selection {
            background: #FFFF00;
        }
    }
    .apply-border {
        border: 1px solid #757575 !important;
    }
</style>